import { Link } from "react-router-dom";
import { Gift, ArrowRight } from "@phosphor-icons/react";

const btn = "whitespace-nowrap inline-flex items-center gap-1.5 rounded-full px-4 py-1.5 text-xs font-semibold uppercase tracking-wider transition-colors duration-200";

export const GiftGuideStrip = () => (
  <aside data-testid="gift-guide-strip" aria-label="Fishing gift guides" className="bg-[#0F172A] text-white">
    <div className="mx-auto max-w-7xl px-6 py-2.5 flex flex-col sm:flex-row items-center justify-between gap-2">
      <p data-testid="gift-guide-strip-text" className="flex items-center gap-2 text-sm">
        <Gift size={18} weight="fill" className="text-[#F59E0B]" />
        <span><strong>Shopping for an angler?</strong> Browse our funny fishing gift guides.</span>
      </p>
      <nav className="flex items-center gap-2">
        <Link to="/gifts/for-her" data-testid="gift-strip-her-btn" className={`${btn} bg-[#F59E0B] text-[#0F172A] hover:bg-white`}>
          <span className="hidden sm:inline">Shop&nbsp;</span>Gifts for Her <ArrowRight size={12} weight="bold" />
        </Link>
        <Link to="/gifts/for-him" data-testid="gift-strip-him-btn" className={`${btn} border border-white/50 hover:bg-white hover:text-[#0F172A]`}>
          <span className="hidden sm:inline">Shop&nbsp;</span>Gifts for Him <ArrowRight size={12} weight="bold" />
        </Link>
      </nav>
    </div>
  </aside>
);
